import { format, parseISO } from 'date-fns';
import { DateRange } from 'react-day-picker';

import { IDatesRange } from 'detailsv2/structure';

export const parseDate = (date?: string | null) => (date ? parseISO(date) : undefined);
export const formatDate = (date?: Date) => (date ? format(date, 'yyyy-MM-dd') : null);
export const parseDateRange = (dateRange?: IDatesRange | null): DateRange => ({
  from: parseDate(dateRange?.start),
  to: parseDate(dateRange?.end),
});
